export const headBody5 = {
    "bone_controllers": [
        {
            "name": "legs_length_long",
            "value": 0
        },
        {
            "name": "waist_length_long",
            "value": 0
        },
        {
            "name": "neck_length_long",
            "value": 0
        },
        {
            "name": "head_size_small",
            "value": 0
        },
        {
            "name": "arms_length_long",
            "value": 0
        },
        {
            "name": "waist_thickness_thick",
            "value": 0
        },
        {
            "name": "arms_thickness_thick",
            "value": 0
        },
        {
            "name": "legs_thickness_thick",
            "value": 0
        }
    ],
}